import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import { pushAdoptsBuyerModal } from '../../../Modals/redux/actionCreators';
import { useDispatch } from 'react-redux';
import { getHasBuyItNow, getAllowOffers, getHasOffers, getHasRejectedOffer, getPrice } from '../../helpers';
import { Url } from '@wix/da-url';
import s from './AdoptableBuyer.scss';
export const AdoptableBuyer = ({ deviation , className  })=>{
    const dispatch = useDispatch();
    const { t  } = useTranslation();
    const allowOffers = getAllowOffers(deviation);
    const hasBuyItNow = getHasBuyItNow(deviation);
    const hasOffer = getHasOffers(deviation);
    const hasRejectedOffer = getHasRejectedOffer(deviation);
    const price = getPrice(deviation);
    const openModal = useCallback(()=>{
        dispatch(pushAdoptsBuyerModal(deviation, 'offer'));
    }, [
        deviation,
        dispatch
    ]);
    const gotoCheckout = useCallback(()=>{
        var _deviation_extended, _deviation_extended_adoptable, _deviation_extended_adoptable_fixedPrice;
        var _deviation_extended_adoptable_fixedPrice_subproductId;
        window.location.assign(Url.checkoutLink((_deviation_extended_adoptable_fixedPrice_subproductId = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : (_deviation_extended_adoptable_fixedPrice = _deviation_extended_adoptable.fixedPrice) === null || _deviation_extended_adoptable_fixedPrice === void 0 ? void 0 : _deviation_extended_adoptable_fixedPrice.subproductId) !== null && _deviation_extended_adoptable_fixedPrice_subproductId !== void 0 ? _deviation_extended_adoptable_fixedPrice_subproductId : 0));
    }, [
        deviation
    ]);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className
    }, allowOffers && !hasOffer && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openModal,
        className: s['offer-button']
    }, t('actionbar.adoptables.makeOffer')), allowOffers && hasOffer && !hasRejectedOffer && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openModal,
        className: s['offer-button']
    }, t('actionbar.adoptables.manageOffer')), allowOffers && hasRejectedOffer && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openModal,
        className: s['offer-button']
    }, t('actionbar.adoptables.viewOffers')), hasBuyItNow && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: allowOffers ? 'solid' : 'outline',
        size: 'medium',
        rounded: true,
        onClick: gotoCheckout
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    })));
};
AdoptableBuyer.displayName = 'AdoptableBuyer';
export default AdoptableBuyer;
